import { useI18n, useTranslate } from "@/lib/i18n";
import type { KitchenBoardPlate } from "@/lib/api/types";
import { batchRows } from "../lib/batch";

/**
 * «المطلوب الآن» — THE BATCH STRIP (T13; D170).
 *
 * `{count}× {name}` over the station's QUEUED + PREPARING plates, count first
 * and biggest batch first: at the grill it is the one thing a screen does
 * better than paper ("six shish, four kofta"). Dish counts only — never per
 * cook. The PAGE decides where it shows: a single-station view whose station
 * has `batchStripEnabled`, never «كل المحطات» and never the order view. With
 * nothing to make it draws nothing.
 */
export function KitchenBatchStrip({ plates }: { plates: readonly KitchenBoardPlate[] }) {
  const t = useTranslate();
  const { locale } = useI18n();
  const rows = batchRows(plates, locale);
  if (rows.length === 0) return null;
  return (
    <section
      data-ui="kitchen-batch"
      data-testid="kitchen-batch"
      aria-label={t((m) => m.kitchen.batchTitle)}
      className="no-print flex flex-wrap items-center"
    >
      <h2 data-ui="kitchen-batch-title" className="whitespace-nowrap">
        {t((m) => m.kitchen.batchTitle)}
      </h2>
      <ul className="flex flex-wrap items-center" data-ui="kitchen-batch-list">
        {rows.map((row) => (
          <li key={row.key} data-ui="kitchen-batch-item" data-testid="kitchen-batch-item" className="flex items-baseline">
            <span data-ui="kitchen-batch-count" className="tabular-nums">
              {row.count}×
            </span>
            <bdi data-ui="kitchen-batch-name">{row.name}</bdi>
          </li>
        ))}
      </ul>
    </section>
  );
}
